/**
 * @module "ethpm"
 */

require('source-map-support/register');

const { EthPM } = require('./ethpm');

export { EthPM };
